/**
 * Card identity. A flashcard is keyed by the normalized English text of the
 * vocab item — the same natural key `extractVocab` dedupes on. The DB stores
 * scheduling state under this key; front/back/audio are re-derived from the
 * bundled lesson JSON at runtime, so content stays the single source of truth.
 *
 * If a content author edits an English string, the old row idles (filtered
 * out because no deck entry matches) and the item re-enters as a new card.
 */
export function cardKey(en: string): string {
  return en.trim().toLowerCase();
}

/** Direction 0 = Georgian front → recall English (v1's only direction). */
export const DIRECTION_KA_TO_EN = 0;
